function escapeRegex(value: string) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function hostCandidates(hostname: string) {
  const normalized = hostname.toLowerCase();
  const noPort = normalized.split(':')[0];
  const candidates = new Set([noPort]);

  if (noPort.startsWith('www.')) {
    candidates.add(noPort.slice(4));
  } else {
    candidates.add(`www.${noPort}`);
  }

  if (noPort.startsWith('m.')) {
    candidates.add(noPort.slice(2));
  } else {
    candidates.add(`m.${noPort}`);
  }

  return Array.from(candidates);
}

function patternToRegex(pattern: string) {
  if (pattern === '*') return /.*/i;
  const escaped = escapeRegex(pattern).replace(/\\\*/g, '.*');
  return new RegExp(`^${escaped}$`, 'i');
}

function originCandidates(origin: string) {
  try {
    const url = new URL(origin);
    const normalizedHostCandidates = hostCandidates(url.hostname);
    const port = url.port ? `:${url.port}` : '';
    return normalizedHostCandidates.map(host => `${url.protocol}//${host}${port}`);
  } catch {
    return [origin.toLowerCase()];
  }
}

export function matchesPattern(value: string, pattern: string) {
  if (!pattern) return false;
  // Support wildcard subdomain patterns like *.example.com
  if (pattern.startsWith('*.')) {
    const root = pattern.slice(2).toLowerCase();
    const lower = value.toLowerCase();
    return lower === root || lower.endsWith(`.${root}`);
  }
  return patternToRegex(pattern).test(value);
}

export function isHostAllowed(hostname: string, allowed: string[] = [], blocked: string[] = []) {
  const candidates = hostCandidates(hostname);
  if (
    blocked.length &&
    blocked.some(pattern => candidates.some(host => matchesPattern(host, pattern)))
  ) {
    return false;
  }
  if (!allowed.length) return true;
  return allowed.some(pattern => candidates.some(host => matchesPattern(host, pattern)));
}

export function isOriginAllowed(origin: string, allowedOrigins: string[] = []) {
  if (!allowedOrigins.length) return true;
  const candidates = originCandidates(origin);
  return allowedOrigins.some(pattern =>
    candidates.some(candidate => matchesPattern(candidate, pattern))
  );
}
